<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button v-if="is_general_manager" @click.native="onOpenCreateModal">Create group</app-button>
        <app-input
            @input.native="onGroupsSearch"
            v-model="search"
            class="input--200"
            type="search"
            placeholder="Search by group name"
            name="search"
        />
        <app-date-picker @change="onChangeFilter" v-model="filter_start" placeholder="From" class="datepicker--filter" />
        <app-date-picker @change="onChangeFilter" v-model="filter_end" placeholder="To" class="datepicker--filter" />
      </app-cells>
      <div v-for="safari_table_item of safari_table" :key="safari_table_item.name" class="safari-block">
        <app-cells>
          <h2 class="title">{{ safari_table_item.name }}</h2>
          <div v-if="safari_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
            :data="safari_table_item.items"
            :columns="table.columns"
            :options="table.options"
            class="table-default"
            :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name>
            <div class="table-default__left">Name</div>
          </template>
          <template #h__orders>Orders<br>available</template>
          <template #h__summary_printed>Summary<br>printed</template>
          <template #h__packing_started>Packing<br>started</template>
          <template #h__requests>Orders<br>to collect</template>
          <template #h__requests_need_payment>Orders<br>unpaid</template>
          <template #h__driver>Passed<br>to driver</template>
          <template #h__start_from><div class="table-default__left">Start from</div></template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                  :to="{ name: 'safari-groups-detail-snacks', params: { id: row.id } }"
                  class="table-default__link-border"
              >
                {{ row.name }}
              </router-link>
            </div>
          </template>
          <template #type="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
              {{ row.type ? row.type.name : '-' }}
            </span>
          </template>
          <template #orders="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.orders_available ? '#77b017' : '#5f5f5f' }">
              {{ row.snack_bar.info.orders_available ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #summary_printed="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.summary_printed ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.summary_printed ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #packing_started="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.packing_started ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.packing_started ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #requests="{ row }">
            <span
                class="status-tag"
                :style="{ 'backgroundColor': row.snack_bar.orders.collected === row.snack_bar.orders.to_be_collected ? '#77b017' : '#f0c427' }"
            >
              {{ row.snack_bar.orders.collected }} / {{ row.snack_bar.orders.to_be_collected }}
            </span>
          </template>
          <template #requests_need_payment="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': !row.snack_bar.orders.need_payment ? '#5f5f5f' : '#e85c20' }"
            >
              {{ row.snack_bar.orders.need_payment }}
            </span>
          </template>
          <template #collected="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.snack_bar.info.collected ? '#77b017' : '#f0c427' }"
            >
              {{ row.snack_bar.info.collected ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #driver="{ row }">
            <span class="status-tag" :style="{ 'backgroundColor': row.snack_bar.info.passed_to_driver ? '#77b017' : '#f0c427' }">
              {{ row.snack_bar.info.passed_to_driver ? 'Yes' : 'No' }}
            </span>
          </template>
          <template #number_of_clients="{ row }">
          <span
              v-tooltip="{ content: clientTableList(row.clients), placement: 'top-start', offset: 10, html: true }"
              :style="{cursor: 'pointer'}"
          >
            {{ row.number_of_clients }}
          </span>
          </template>
          <template #tour_start="{ row }">
            {{ dateFormatTable(row.tour_start) }}
          </template>
          <template #tour_end="{ row }">
            {{ dateFormatTable(row.tour_end) }}
          </template>
          <template #start_from="{ row }">
            <div class="table-default__left">{{ row.start_from?.short_name || '-' }}</div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
              :clickHandler="onClickPagination"
              v-if="pagination.pages > 1"
              v-model="pagination.page"
              :page-count="pagination.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
    <modal
        name="safari-group-form"
        :width="700"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('safari-group-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Create Safari group</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-grid>
              <template #item-1>
                <app-form-group label="Group name" label-for="group_name" required>
                  <app-input
                      v-model="form.name"
                      :error="$v.form.name.$error"
                      id="group_name"
                      placeholder="Group name"
                      name="group_name"
                  />
                  <template #error>
                    <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Type" required>
                  <app-select
                    v-model="form.type"
                    :reduce="item => item.code"
                    :options="group_type_options"
                    :clearable="false"
                    placeholder="Type"
                    :error="$v.form.type.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Cars required" required>
                  <app-input
                      v-model.number="form.cars_required"
                      type="number"
                      min="0"
                      :error="$v.form.cars_required.$error"
                      placeholder="Cars required"
                  />
                  <template #error>
                    <div v-if="$v.form.cars_required.$dirty && !$v.form.cars_required.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour start" required>
                  <app-date-picker
                    @input="onSetTourStart"
                    v-model="form.tour_start"
                    placeholder="Tour start"
                    :error="$v.form.tour_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.tour_start.$dirty && !$v.form.tour_start.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour finish" required>
                  <app-date-picker
                    v-model="form.tour_end"
                    :readonly="!form.tour_start"
                    :default-value="form.tour_start"
                    placeholder="Tour finish"
                    ref="tour_end"
                    :error="$v.form.tour_end.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.tour_end.$dirty && !$v.form.tour_end.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="Short itinerary" label-for="short_itinerary" required>
                  <app-input
                      v-model="form.short_itinerary"
                      id="short_itinerary"
                      placeholder="Tar, Ngo, 2Ser"
                      name="short_itinerary"
                      :error="$v.form.short_itinerary.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.short_itinerary.$dirty && !$v.form.short_itinerary.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Start from">
                  <app-select
                    @input="onLocationStartSelected"
                    @search="onLocationSearch"
                    v-model="form.start_from"
                    :options="location_options"
                    placeholder="Select"
                  />
                </app-form-group>
                <app-form-group label="Finish at">
                  <app-select
                    @input="onLocationFinishSelected"
                    @search="onLocationSearch"
                    v-model="form.finish_at"
                    :options="location_options"
                    placeholder="Select"
                  />
                </app-form-group>
              </template>
            </app-grid>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">{{ groupIdToUpdate ? 'Update': 'Create' }}</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getGoogleSearch,
  getSafariGroupsByDates,
  getSafariGroupTypes,
  patchSafariGroups,
  postLocation,
  postSafariGroups,
} from '@/http'
import debounce from 'lodash/debounce'
import { required } from 'vuelidate/lib/validators'
import { format, parse } from 'date-fns'

export default {
  name: 'SafariSnackBarUpcomingList',
  data() {
    return {
      is_loaded: false,
      search: null,
      safari_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: [
          'name',
          'number_of_clients',
          'cars_required',
          'type',
          'orders',
          'summary_printed',
          'packing_started',
          'requests',
          'requests_need_payment',
          'collected',
          'driver',
          'tour_start',
          'tour_end',
          'start_from'
        ],
        options: {
          headings: {
            'name': 'Name',
            'number_of_clients': 'Pax',
            'cars_required': 'Cars',
            'type': 'Type',
            'orders': 'Orders available',
            'summary_printed': 'Summary printed',
            'packing_started': 'Packing started',
            'requests': 'Orders to collect',
            'requests_need_payment': 'Orders unpaid',
            'collected': 'Collected',
            'driver': 'Passed to driver',
            'tour_start': 'Start',
            'tour_end': 'Finish',
            'start_from': 'Start from',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      groupIdToUpdate: null,
      category_filter: 'upcoming',
      filter_start: null,
      filter_end: null,
      filter_clients: false,
      group_type_options: [],
      table_preloader: false,
      location_options: [],
    }
  },
  validations: {
    form: {
      name: { required },
      type: { required },
      tour_start: { required },
      tour_end: { required },
      cars_required: { required },
      short_itinerary: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    this.fetchItems()
    getSafariGroupTypes().then(res => {
      this.group_type_options = res.data
      if (this.group_type_options.length) this.form.type = this.group_type_options[0].code
    })
  },
  methods: {
    onLocationStartSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form.start_from = res.data
      })
    },
    onLocationFinishSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form.finish_at = res.data
      })
    },
    onSetTourStart() {
      this.$refs.tour_end.$children[0].focus()
    },
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    onChangeFilter() {
      this.search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onOpenCreateModal() {
      this.form = {
        type: this.group_type_options[0].code
      }
      this.$v.form.$reset()
      this.groupIdToUpdate = null
      this.$modal.show('safari-group-form')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateFormatTable(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM') : '-'
    },
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        category: this.search ? '' : 'upcoming',
        group_by: 'tour_start',
        range_type: 'day',
        type_exclude: 'gamepackage'
      }
      if (!this.search && this.filter_start) params.tour_start__gte = this.filter_start
      if (!this.search && this.filter_end) params.tour_start__lte = this.filter_end
      getSafariGroupsByDates(params)
        .then(res => {
          this.safari_table = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onCheckForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (this.groupIdToUpdate) {
        patchSafariGroups(this.groupIdToUpdate, this.form)
          .finally(() => { this.$refs.submit.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Group updated',
            })
            this.fetchItems(this.pagination.page)
            this.$modal.hide('safari-group-form')
            this.form = {}
            this.groupIdToUpdate = null
          })
      } else {
        postSafariGroups(this.normalizeForm())
          .finally(() => { this.$refs.submit.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Group created',
            })
            this.fetchItems(this.pagination.page)
            this.$modal.hide('safari-group-form')
            this.form = {}
          })
      }
    },
    normalizeForm() {
      const normalizedForm = { ...this.form }

      if (normalizedForm.start_from) normalizedForm.start_from = normalizedForm.start_from.id
      if (normalizedForm.finish_at) normalizedForm.finish_at = normalizedForm.finish_at.id

      return normalizedForm
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.safari-block
  margin-bottom: 30px
</style>
